// sections
import '../components/pagination/scripts';
import '../sections/artistOverview/scripts';

// components
import '../components';
